export default __webpack_public_path__ + "static/fastfood-presentation-61da5b00e67f7bef3f5f259009480afd.png";